import { CarType } from '@digital-dealer/enums';
import { TTextsOverride } from '@digital-dealer/texts-service';
import { LeasingStep, CitizenType, HousingType } from '@leasing/enums';
import LeasingAction from '@leasing/model-viewer/enums/LeasingAction';

const textsOverride: TTextsOverride = {
  common: {
    moneyUnits: {
      businessType: 'kr/mån',
    },
  },
  modules: {
    modelChooser: {
      priceFrom: {
        [CarType.Van]: 'Företagsleasing från',
      },
    },
    modelViewer: {
      checkout: {
        title: {
          [CarType.PersonalCar]: 'Leasing',
          [CarType.Van]: 'Leasing',
        },
        total: 'Månadskostnad',
      },
    },
  },
  leasing: {
    housingType: {
      [HousingType.Ownership]: 'Ägarbostad',
      [HousingType.Rental]: 'Hyresfastighet',
      [HousingType.Shared]: 'Bostadsrättsförening',
      [HousingType.Parental]: 'Bor hemma',
    },
    citizenType: {
      [CitizenType.Citizenship]: 'Ja',
      [CitizenType.ResidentPermit]: 'Nej – har permanent uppehållstillstånd',
      [CitizenType.Foreigner]: 'Nej',
    },
    fields: {
      labels: {
        creditValidation: {
          bankRegNumber: 'Bank, reg.nr.',
          bankAccountNumber: 'Bankkontonummer.',
          yearlyIncome: 'Din årliga bruttoinkomst',
          monthlyAvailableAmount: 'Månatlig disponibel inkomst för ditt hushåll',
          numberOfAdults: 'Antal vuxna i hushållet',
          numberOfAdultsHelper: 'Barn över 18 år ingår inte',
          numberOfChildren: 'Antal barn i hushållet',
          numberOfChildrenHelper: 'Barn över 18 år ingår inte',
          housingType: 'Nuvarande bostadstyp',
          citizenType: 'Är du dansk medborgare?',
        },
      },
      errors: {
        creditValidation: {
          bankRegNumber: 'Felaktigt bankreg.nr.',
          bankAccountNumber: 'Felaktigt bankkontonummer',
        },
      },
    },
    common: {
      duration: 'Avtalstid',
      downPayment: 'Handpenning',
      totalPriceForPeriod: 'Total kostnad',
      units: {
        kmPerYear: 'mil/år',
        months: 'månader',
      },
    },
    modules: {
      modelChooser: {
        subTitle: {
          [CarType.PersonalCar]: '',
          [CarType.Van]: 'Alla priser är exkl. moms',
        },
      },
      modelViewer: {
        configuration: {
          steps: {
            [LeasingStep.LeasingOptions]: {
              title: 'Leasing optioner',
              expandedTitle: 'Välj avtalstid och miltal',
              kilometerOption: {
                title: 'Miltal',
              },
            },
          },
        },
        checkout: {
          totalPriceForPeriod: {
            totalPaymentForPeriod: (period: number): string => `Finansiering - månadsvis x ${period} månader`,
            deliveryCost: 'Leveranskostnad',
            total: 'Totalt',
          },
          additionalTechnicalSpecs: {
            residualValue: 'Restvärde',
          },
          actions: {
            [LeasingAction.PurchaseOnline]: { // Purchase flow is not supported for Swedish version
              actionButtonTitle: '',
              title: '',
              successPage: {
                title: '',
                description: '',
              },
            },
          },
          hints: { // Purchase flow is not supported for Swedish version
            [LeasingAction.PurchaseOnline]: [
              '',
              '',
              '',
            ],
          },
        },
      },
    },
  },
};

export default textsOverride;
